<div [@slideInOut]="active ? 'show' : 'hide'" class="legend-animate-container">
    <div>
           <div [@.disabled]="disableAnimation()">
        <mat-accordion multi="false">

            <mat-expansion-panel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[1].isOpen, 'glyphicon-light-chevron-right': !group[1].isOpen}"></i>
                        {{"legend.GroundCover"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg1_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.GroundCover"|translate}}' title='{{"legend.GroundCover"|translate}}' width="230"
                        height="360">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[2].isOpen, 'glyphicon-light-chevron-right': !group[2].isOpen}"></i>
                        {{"legend.LineOrPoint-shapedVegetation"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg2_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.LineOrPoint-shapedVegetation"|translate}}'
                        title='{{"legend.LineOrPoint-shapedVegetation"|translate}}' width="230" height="230">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[3].isOpen, 'glyphicon-light-chevron-right': !group[3].isOpen}"></i>
                        {{"legend.Buildings"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg3_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.Buildings"|translate}}' title='{{"legend.Buildings"|translate}}' width="230" height="840">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[4].isOpen, 'glyphicon-light-chevron-right': !group[4].isOpen}"></i>
                        {{"legend.Hydrography"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg4_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.Hydrography"|translate}}' title='{{"legend.Hydrography"|translate}}' width="230"
                        height="870">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[5].isOpen, 'glyphicon-light-chevron-right': !group[5].isOpen}"></i>
                        {{"legend.NetworkRoadsPaths"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg5_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.NetworkRoadsPaths"|translate}}'
                        title='{{"legend.NetworkRoadsPaths"|translate}}' width="230" height="810">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[6].isOpen, 'glyphicon-light-chevron-right': !group[6].isOpen}"></i>
                        {{"legend.SpecialZones"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg6_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.SpecialZones"|translate}}' title='{{"legend.SpecialZones"|translate}}'
                        width="230" height="800">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[7].isOpen, 'glyphicon-light-chevron-right': !group[7].isOpen}"></i>
                        {{"legend.ElectricHigh-voltageNetwork"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg7_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.ElectricHigh-voltageNetwork"|translate}}'
                        title='{{"legend.ElectricHigh-voltageNetwork"|translate}}' width="230" height="245">
                </div>
            </mat-expansion-panel>
            
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[11].isOpen, 'glyphicon-light-chevron-right': !group[11].isOpen}"></i>
                        {{"legend.ConstructionsVariousObjects"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg11_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.ConstructionsVariousObjects"|translate}}'
                        title='{{"legend.ConstructionsVariousObjects"|translate}}' width="230" height="830">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[8].isOpen, 'glyphicon-light-chevron-right': !group[8].isOpen}"></i>
                        {{"legend.FieldPerformances"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg8_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.FieldPerformances"|translate}}' title='{{"legend.FieldPerformances"|translate}}'
                        width="230" height="280">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[9].isOpen, 'glyphicon-light-chevron-right': !group[9].isOpen}"></i>
                        {{"legend.AdministrativeData"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg9_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.AdministrativeData"|translate}}'
                        title='{{"legend.AdministrativeData"|translate}}' width="230" height="200">
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pull-left glyphicon icon-container"
                            ng-class="{'glyphicon-light-chevron-down': group[10].isOpen, 'glyphicon-light-chevron-right': !group[10].isOpen}"></i>
                        {{"legend.Toponyms"|translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <img src="./assets/legend/ImgWebmapGray/leg10_wm_{{translateService.currentLang.slice(0, -1)}}_g.png" alt='{{"legend.Toponyms"|translate}}' title='{{"legend.Toponyms"|translate}}' width="230"
                        height="480">
                </div>
            </mat-expansion-panel>

        </mat-accordion>
    </div>
</div>